import { FilterBase } from "../filterBase";
import { DATA_TYPES } from "../filterConstants";

export class ElementFilter extends FilterBase {
  constructor(filterName, filterType, dataScopes, information, visibility, restrictedToScope) {
    super(filterName, filterType, DATA_TYPES.ELEMENT, dataScopes, information, visibility, restrictedToScope, false);
  }

  formatCompareData(a, b) {
    return [a?.orderValue, b?.orderValue]
  }

  additionalFilters(data) {
    return data; // can not filter element data.
  }
}